module.exports = __webpack_public_path__ + "img/ALAN.e04218f1.png";